import { render, staticRenderFns } from "./ModalReminderPreview.vue?vue&type=template&id=e2eb5eb6&"
import script from "./ModalReminderPreview.vue?vue&type=script&lang=js&"
export * from "./ModalReminderPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports